import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import ReportView from '@/pages/gmb-audit/result/components/ReportView';
import {
  ReportErrorState,
  UnavailableState,
  WaitingState,
} from '@/pages/gmb-audit/result/components/ReportStateViews';
import { fetchAuditReport } from '@/pages/gmb-audit/data/auditApi';
import type { AuditReport, ReportLoadStatus } from '@/types/gmb';

export default function GmbAuditResultPage() {
  const { auditId } = useParams<{ auditId: string }>();
  const [status, setStatus] = useState<ReportLoadStatus>('waiting');
  const [report, setReport] = useState<AuditReport | null>(null);

  useEffect(() => {
    let active = true;

    const load = async () => {
      if (!auditId) {
        if (active) setStatus('unavailable');
        return;
      }
      try {
        const dto = await fetchAuditReport(auditId);
        if (!active) return;
        if (!dto) {
          setReport(null);
          setStatus('unavailable');
          return;
        }
        setReport(dto);
        setStatus('completed');
      } catch {
        if (active) setStatus('error');
      }
    };

    load();
    return () => {
      active = false;
    };
  }, [auditId]);

  return (
    <SiteLayout>
      {status === 'waiting' && <WaitingState />}
      {status === 'unavailable' && <UnavailableState auditId={auditId} />}
      {status === 'error' && <ReportErrorState variant="api-error" />}
      {status === 'completed' && report && <ReportView report={report} />}
    </SiteLayout>
  );
}